export function JSObjectToMap(obj: { [x: string]: any; }) {
    const map = new Map();
    for (const key of Object.keys(obj)) {
        map.set(key, obj[key]);
    }
    return map;
}
